import { FC, memo } from 'react'

import Component from './Component'
import CalendarFiltersDrawerProvider from './contexts/CalendarFiltersManager/Provider'

export type SubmitedFilterDates = {
  dateFeedback?: string
  dateFilterType?: string
  startDate?: string
  finalDate?: string
  startHour?: string
  finalHour?: string
  startDataForAPI?: string
  finalDataForAPI?: string
}

export type CalendarFiltersButtonProps = {
  onCloseModal?: () => void
  onOpenModal?: () => void
  onSubmit: (dates: SubmitedFilterDates) => void
  modalTitle?: string
  defaultDates?: SubmitedFilterDates
}

type Props = CalendarFiltersButtonProps & {
  trigger: JSX.Element
}

const CalendarFilters: FC<Props> = ({ modalTitle = 'Selecione as datas', trigger, ...props }) => {
  return (
    <CalendarFiltersDrawerProvider modalTitle={modalTitle} {...props}>
      <Component trigger={trigger} />
    </CalendarFiltersDrawerProvider>
  )
}

export default memo(CalendarFilters)
